import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabecerasDestinos from "../components/destinosSecciones/CabecerasDestinos";
import HoteleriaVillaCarlosPaz from "../components/hoteleria/HoteleriaVillaCarlosPaz";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionVillaCarlosPazPri from "../components/diversion/DiversionVillaCarlosPazPri";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";


export default function PriCarlosPaz() {
    return (
      <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/cordoba/cordoba.jpg"}
        HeaderTitle="Villa Carlos Paz"
        Parent="primarios"
        PageTitle="Villa Carlos Paz"
      />
      <CabecerasDestinos destino={"Villa Carlos Paz"} />
      <VideoPromoDestino
        background="assets/img/villaCarlosPazPri/banner-vcp.jpg"
        YoutubeVideoId="_D9_OOZ3IE0"
        TextoPromo="Conoce Villa Carlos Paz, tu viaje de egresados."
      />
      <HoteleriaVillaCarlosPaz/>
      <DiversionVillaCarlosPazPri hasBg={true} />
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
      );
}